import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants';
import churchDashboardService from '@/services/church-dashboard.service';

type DismissNotificationVariables = {
  churchId: string;
  id: string;
};

export const useDismissNotificationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ churchId, id }: DismissNotificationVariables) =>
      churchDashboardService.dismissNotification({ churchId, id }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.DASHBOARD_NOTIFICATIONS] });
    },
  });
};
